import { useTranslation } from 'react-i18next'

export function StructuredData() {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language

  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'SoftwareApplication',
        name: 'Flight Journal',
        applicationCategory: 'BusinessApplication',
        operatingSystem: 'Web',
        offers: {
          '@type': 'Offer',
          price: '0',
          priceCurrency: 'BRL',
        },
        description:
          currentLanguage === 'pt-BR'
            ? 'Sistema profissional de diário de bordo eletrônico em conformidade com ANAC para operadores, pilotos e equipes de manutenção'
            : 'Professional ANAC-compliant electronic flight journal system for operators, pilots, and maintenance personnel',
        inLanguage: ['pt-BR', 'en-US'],
        featureList: [
          currentLanguage === 'pt-BR'
            ? 'Gestão de frota'
            : 'Fleet management',
          currentLanguage === 'pt-BR'
            ? 'Rastreamento de voo'
            : 'Flight tracking',
          currentLanguage === 'pt-BR'
            ? 'Monitoramento de manutenção'
            : 'Maintenance monitoring',
          currentLanguage === 'pt-BR'
            ? 'Conformidade ANAC'
            : 'ANAC compliance',
        ],
      },
      {
        '@type': 'Organization',
        name: 'Montenegro Services',
        url: 'https://montenegroservices.cloud',
        logo: 'https://montenegroservices.cloud/logo.png',
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'acmh360@gmail.com',
          contactType: 'customer support',
          areaServed: 'BR',
          availableLanguage: ['Portuguese', 'English'],
        },
      },
      {
        '@type': 'WebSite',
        name: 'Flight Journal',
        url: 'https://montenegroservices.cloud',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate:
              'https://montenegroservices.cloud/search?q={search_term_string}',
          },
          'query-input': 'required name=search_term_string',
        },
      },
    ],
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  )
}
